import React, { Component } from 'react';
import { Load, Warning } from './basic';
import Datepicker from './datepicker';
import axios from 'axios';
import '../../public/less/chart.less';
import dateHelper from '../../helpers/date.js';

module.exports = class chartForm extends Component {

    constructor(props) {
        super(props);
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();

        this.state = {
            type: this.props.ChartType,
            startDate: new Date(y, m, 1),
            endDate: new Date(y, m + 1, 0),
            moreData: this.props.Data
        }
    };

    DateChange(newDate, type) {
        var startDate = this.state.startDate;
        var endDate = this.state.endDate;

        if (type == "from") {
            startDate = newDate;
            this.setState({ startDate: newDate });
        } else {
            endDate = newDate;
            this.setState({ endDate: newDate });
        }

        this
            .chart
            .destroy();
        this.loadData(startDate, endDate);

    };

    componentDidMount() {
        this.ID = this.props.ID;
        var chartMaxTicks = this.props.MaxTicks;

        //  Chart.defaults.global.legend.display = false;

        this.loadData(this.state.startDate, this.state.endDate);
    };

    loadData(startDate, endDate) {
        this
            ._loading
            .Show();

        var params = this.props.Data;
        if (!params) {
            params = {};
        }
        params.fromDate = dateHelper.fromDateToDBStr(startDate);
        params.toDate = dateHelper.fromDateToDBStr(endDate);

        axios
            .get(this.props.ChartAjaxUrl, { params: params })
            .then(function (data) {
                this
                    ._loading
                    .Hide();
                this.data = data.data;
                this.createChart(this.state.type);
            }.bind(this))
            .catch(function (error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                this
                    ._loading
                    .Hide();
                this.setState({ isError: true });
                console.log(error);
            }.bind(this));
    };

    changeChartType() {
        var newType = "";
        if (this.state.type == "line")
            newType = "pie";
        else
            newType = "line";

        this.setState({ type: newType });

        this
            .chart
            .destroy();

        this.createChart(newType);
    };

    createChart(newType) {

        var ctx = document.getElementById(this.ID);
        var data = this.changeBackground(newType, this.data, this.state.startDate, this.state.endDate);

        var displayXAxes = true;
        if (newType == 'pie')
            displayXAxes = false;

        for (var j = 0; j < this.data.datasets.length; j++) {
            this.data.datasets[j].lineTension = 0.3;
            this.data.datasets[j].pointRadius = 1;
            this.data.datasets[j].borderWidth = 1;
        }

        var myChart = new Chart(ctx, {
            scaleShowVerticalLines: false,
            type: newType,
            data: this.data,
            options: {
                scales: {
                    xAxes: [
                        {
                            display: displayXAxes,
                            gridLines: {
                                drawOnChartArea: false
                            },
                            // afterTickToLabelConversion: function (data) {     var xLabels = data.ticks;
                            //   var chartMaxTicks = this.props.MaxTicks;     xLabels.forEach(function
                            // (labels, i) {         if (chartMaxTicks != -1 && i %
                            // Math.round(data.ticks.length / chartMaxTicks) != 0) {             xLabels[i]
                            // = '';         }     }); }.bind(this)
                        }
                    ]
                },
                legend: {
                    display: false
                }
            }
        });

        this.chart = myChart;

        myChart.render();
    };

    changeBackground(type) {
        if (type == "pie") {
            for (var j = 0; j < this.data.datasets.length; j++) {
                var colors = [];
                var numberOfDays = this.daysBetween(this.state.startDate, this.state.endDate);
                for (var i = 1; i <= numberOfDays; i++) {
                    colors.push(this.randomColor());
                }
                this.data.datasets[j].backgroundColor = colors;
            }
        } else {
            if (this.data.datasets.length == 1)
                this.data.datasets[0].backgroundColor = "rgba(131,134,211,0.7)";
            else {
                for (var j = 0; j < this.data.datasets.length; j++) {
                    this.data.datasets[j].backgroundColor = this.randomColor();
                }
            }
        }
    };

    // returns random color
    randomColor() {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        return "rgb(" + r + "," + g + "," + b + ")";
    }

    daysBetween(date1, date2) {
        return Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
    }

    render() {
        var checkboxId = 'toggle_' + this.props.ID;

        var fromDate = this
            .state
            .startDate
            .toLocaleDateString();
        var toDate = this
            .state
            .endDate
            .toLocaleDateString();

        var barImage = getImageObjectForBar(this.type);

        var errorClass = "hidden error";
        if (this.state.isError) {
            errorClass = "error";
        }
        return (
            <div className='chartContainer' id={this.props.containerId}>

                <Load
                    ref={(loading) => {
                        this._loading = loading;
                    }} />
                <div className={errorClass}>An error occured.</div>
                <div >
                    <div className='chartPickDates'>
                        <Datepicker
                            ContainerType='label'
                            type="start"
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            Label="From date"
                            onChange={e => this.DateChange(e, 'from')} />
                        <Datepicker
                            ContainerType='label'
                            type="end"
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            Label="To date"
                            onChange={e => this.DateChange(e, 'to')}
                            className='bottomLoad' />
                        <Warning
                            ref={(warning) => {
                                this._warning = warning;
                            }} />
                    </div>
                    <div className='selectChartType text-right'>
                        {getImageObjectForPie(this.state.type)}
                        <div className='toggle'>
                            <input
                                type='checkbox'
                                id={checkboxId}
                                className='cmn-toggle cmn-toggle-round'
                                onClick={() => this.changeChartType()}
                                defaultChecked={true} />
                            <label htmlFor={checkboxId}></label>
                        </div>
                        {getImageObjectForBar(this.state.type)}

                    </div>
                </div>
                <canvas className='chartJs topBorder' id={this.props.ID}></canvas>
            </div>
        )
    }
};

var getImageObjectForPie = function (type) {
    if (type == "pie")
        return (<img src='/gallery/chart-pie-active.png' className='chart-pie' />);
    return (<img src='/gallery/chart-pie.png' className='chart-pie' />);
}

var getImageObjectForBar = function (type) {
    if (type == "line")
        return (<img src='/gallery/chart-bar-active.png' className='chart-bar' />);
    return (<img src='/gallery/chart-bar.png' className='chart-bar' />);
}


// WEBPACK FOOTER //
// ./modules/common/chart.jsx